import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { UpdateClientsRequest } from 'src/app/model/management-config/clientManagement';
import { User } from 'src/app/model/user';
import { ClientManagementService } from 'src/app/service/clientManagement.service';
import { NotificationService } from 'src/app/service/notification.service';
import {TestsComponent} from '../../tests/tests.component';
import {Tests} from '../../../model/tests/tests';
import {TestsService} from "../../../service/tests.service";

@Component({
  selector: 'app-edit-client',
  templateUrl: './edit-client.component.html',
  styleUrls: ['./edit-client.component.scss']
})
export class EditClientComponent implements OnInit {

  @ViewChild(TestsComponent) testsComponent: TestsComponent;

  _clientForm: FormGroup;
  client: UpdateClientsRequest = new UpdateClientsRequest();

  profile: User = new User;
  email: string;
  tests: Tests;

  constructor(
    private clientService: ClientManagementService,
    private _formBuilder: FormBuilder,
    private _localStorage: LocalStorageService,
    private _notificationService: NotificationService,
    private testsService: TestsService,
    public dialogRef: MatDialogRef<EditClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UpdateClientsRequest
  ) { }

  ngOnInit(): void {
    this._clientForm = this._formBuilder.group({
      clientId: new FormControl({ value: this.data.clientId, disabled: true }),
      clientName: new FormControl({value: this.data.clientName, disabled: true }),
      clientDesc: new FormControl({ value: this.data.clientDesc, disabled: false }),
      createdBy: new FormControl({ value: this.client.createdBy, disabled: false }),

    });
    this.testsService.getClientTests(this.data.clientId).subscribe(
      result => this.tests = result.tests,
      error => console.log(error)
    );
  }

  onSubmit() {
    //alert(this.data.clientName);
    this.client = this._clientForm.value;
    this.client.tests = this.testsComponent.tests.value;
    this.client.clientId = this.data.clientId;
    this.client.clientName = this.data.clientName;
    this.client.createdBy = this._localStorage.retrieve('profile').displayName;
    this.clientService.editClientRequests(this.client)
      .subscribe(data => {
        console.log(data)
        this.dialogRef.close(this._clientForm.value);
        if(data.successFlag){
          this._notificationService.success('Client updated successfully');
          }else{
            this._notificationService.error('Client update failed');
          }
      }, error => console.log(error));
  }
}
